import React from "react";

import { css } from "@emotion/css";
import BGImg from "../../../img/jpg/retailers/bg.jpg";
import BGMImg from "../../../img/jpg/retailers/bgmobile.jpg";
import { desktop, laptop, mobile, tablet } from "../../../styles/breakpoints";
import buttons from "../../../styles/buttons";
import { Link } from "react-router-dom";
import { useI18n } from "../../../i18n";

const Hero = () => {
  const { t } = useI18n();
  return (
    <div className={style.main}>
      <div className={style.container}>
        <h1>
          {t("retailers_precision1")}
          <br />
          {t("retailers_precision2")}
          <br />
          {t("retailers_precision3")}
        </h1>
        <div className="wrapper">
          <p>{t("retailers_reduced")}</p>
            <Link
              to={"/book"}
              className={buttons.primary}
            >
              {t("retailers_book_demo")}
            </Link>
        </div>
      </div>
    </div>
  );
};

const style = {
  main: css({
    backgroundColor: "#fff",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    height: 1200,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    backgroundSize: "cover",
    backgroundImage: `url(${BGImg})`,

    [desktop]: {
      backgroundSize: "2300px auto",
      backgroundPosition: "top center",
      alignItems: "stretch",
      height: 1000,
    },
    [laptop]: {
      backgroundSize: "cover",
      backgroundImage: `url(${BGMImg})`,
      height: 1700,
    },
    [tablet]: {
      height: 1200,
    },
  }),
  container: css({
    top: 0,
    zIndex: 2,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "flex-start",
    width: 645,
    margin: "auto",
    paddingRight: 420,
    paddingTop: 0,
    marginTop: "-140px",

    h1: {
      color: "#000",
      fontFamily: "Syne",
      fontSize: 95,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "92.632%",
      marginBottom: 20,
      maxWidth: 645,
    },
    p: {
      color: "#000",
      fontFamily: "Inter",
      fontSize: 18,
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
      letterSpacing: 0.36,
      width: 196,
    },

    ".wrapper": {
      gap: 20,
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
    },
    [desktop]: {
      width: "max-content",
      maxWidth: 1300,
      marginLeft: 50,
      marginRight: 50,
      marginTop: 0,

      h1: {
        fontSize: 80,
        lineHeight: "81px",
        marginBottom: 20,
        width: 573,
      },
    },
    [laptop]: {
      marginLeft: 40,
      marginRight: 40,
      marginTop: "-220px",

      h1: {
        fontSize: 72,
        lineHeight: "75px",
        width: 531,
        marginBottom: 20,
      },
      ".wrapper": {
        flexDirection: "column",
        alignItems: "flex-start",
      },
    },
    [tablet]: {
      marginLeft: 22,
      marginRight: 22,
      marginTop: "-200px",

      h1: {
        fontSize: 38,
        lineHeight: "42px",
        width: 290,
      },
      p: {
        fontSize: 14,
        letterSpacing: 0.28,
        width: 176,
      },
      ".wrapper": {
        gap: 12,
      },
    },
    [mobile]: {
      width: "auto",
      h1: {
        width: "auto",
      },
    },
  }),
};

export default Hero;
